// Projects pulled from the live site's image set. Each entry is a
// real photograph or rendering hosted in /public/photos so the
// projects page stays self-contained — no Squarespace CDN dependency.

export const projects = [
  {
    id: "guesthouse",
    name: "Bozeman Guesthouse",
    type: "Residential · Accessory Dwelling",
    location: "Bozeman, MT",
    year: 2021,
    photo: "/photos/guesthouse-hero.jpg",
    photoAlt:
      "A two-story contemporary guesthouse clad in vertical cedar with a cantilevered steel-and-wood staircase rising along its front face.",
    blurb:
      "A two-story accessory dwelling stitched into a Bozeman side yard. Vertical cedar warms a board-formed concrete base; a cantilevered steel stair pulls the volume upward and frames the entry below.",
    features: ["Vertical cedar siding", "Board-formed concrete base", "Cantilevered steel stair"],
  },
  {
    id: "guesthouse-night",
    name: "Side Street Light Study",
    type: "Residential · Photography",
    location: "Bozeman, MT",
    year: 2021,
    photo: "/photos/guesthouse-detail.jpg",
    photoAlt:
      "The same guesthouse photographed from across the street at dusk, glowing warm through clerestory windows as red car-light streaks blur across the foreground.",
    blurb:
      "Dusk study of the same guesthouse. The interior glow reveals a clerestory band that disappears in daylight — and the long-exposure light streaks read the building from a passing car the way the neighborhood actually sees it.",
    features: ["Clerestory daylighting", "Warm interior reveal", "Street-edge presence"],
  },
  {
    id: "ada-cabin",
    name: "Foothills ADU",
    type: "Residential · Concept Render",
    location: "Gallatin Valley, MT",
    year: 2024,
    photo: "/photos/ada-cover.png",
    photoAlt:
      "A render of a small dark-clad cabin with a steep gabled roof and a covered porch, sitting in a meadow surrounded by aspens and pines.",
    blurb:
      "A dark-clad single-bedroom cabin with a gable lifted just enough to make room for a sleeping loft. The covered porch faces south, the bedroom faces the trees, and the form is small enough to slip through a tight setback.",
    features: ["Gabled sleeping loft", "South-facing porch", "Compact ADU footprint"],
  },
  {
    id: "section-house",
    name: "Hillside Section House",
    type: "Residential · Schematic",
    location: "Bridger Foothills, MT",
    year: 2023,
    photo: "/photos/schematic-section.png",
    photoAlt:
      "A schematic cutaway rendering showing the interior layout of a two-story house with a gabled roof — kitchen and living space on the upper level, garage and bike storage on the lower.",
    blurb:
      "A schematic cut through a hillside house — kitchen and living up where the view is, bikes and gear tucked into the bench below. The section is the design tool here: program follows topography, not the other way around.",
    features: ["Two-level program", "Hillside bench", "Section-driven plan"],
  },
  {
    id: "deer-house",
    name: "Aspen Bench Cabin",
    type: "Residential · Built",
    location: "SW Montana",
    year: 2023,
    photo: "/photos/construction-detail.jpg",
    photoAlt:
      "A small dark-stained cabin with a deep covered porch perched on a hillside above a meadow, with two mule deer grazing in the foreground beside young aspens.",
    blurb:
      "A weekend retreat sitting light on its bench above a meadow. Cable rail keeps the porch open to the view; a deep overhang protects glass from summer sun without giving up the winter angle.",
    features: ["Cable rail porch", "Deep solar overhang", "Bench-side siting"],
  },
  {
    id: "kitchen-render",
    name: "Long Window Kitchen",
    type: "Residential · Interior Render",
    location: "Confidential",
    year: 2024,
    photo: "/photos/kitchen-render.png",
    photoAlt:
      "An interior render of a modern kitchen and dining nook with a long horizontal window framing a mountain view; a figure sits at a built-in banquette.",
    blurb:
      "A study of a single horizontal opening — sized to the seated eye line at the banquette, run continuous past the kitchen, terminated only where structure demands. One window, one room, one view.",
    features: ["Continuous ribbon window", "Built-in banquette", "View-aligned plan"],
  },
];
